export default "__VITE_ASSET__a3c37090__"